import styled from 'styled-components';

import { MiniBadge } from '@xing-com/badge';
import { Card as BaseCard } from '@xing-com/card';
import { SGapCol } from '@xing-com/crate-jobs-components-columns';
import { OptimisticPublicationDate } from '@xing-com/crate-jobs-components-optimistic-publication-date';
import { lineClamp } from '@xing-com/crate-utils-line-clamp';
import { mediaConfined } from '@xing-com/layout-tokens';
import { Marker as BaseMarker } from '@xing-com/marker';
import { ProfileImage } from '@xing-com/profile-image';
import { spaceM, spaceXS, xdlColorText } from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

export const Card = styled(BaseCard)`
  color: ${xdlColorText};
  border: none;
  padding: 0;

  > div {
    flex-direction: row;
  }

  &:hover,
  &:focus,
  &:focus-within {
    z-index: 1;

    &::after {
      border: none;
    }
  }
`;

export const Image = styled(ProfileImage)`
  pointer-events: none;
`;

export const Content = styled(SGapCol)`
  width: 100%;
  margin-left: ${spaceM};

  @media ${mediaConfined} {
    gap: ${spaceM};
  }
`;

export const Header = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
`;

export const Marker = styled(BaseMarker)`
  width: fit-content;
`;

export const Title = styled(Headline)`
  ${lineClamp(2)};
  word-break: break-word;
`;

export const City = styled(BodyCopy)`
  ${lineClamp(1)};
  word-break: break-all;
`;

export const Company = styled(BodyCopy)`
  ${lineClamp(1)};
  word-break: break-all;
`;

export const BottomCol = styled(SGapCol)`
  @media ${mediaConfined} {
    gap: ${spaceM};
  }
`;

export const PublicationDate = styled(OptimisticPublicationDate).attrs({
  lineHeight: 'dense',
  noMargin: true,
})`
  display: flex;
  align-items: center;
`;

export const Notification = styled(MiniBadge)`
  margin-right: ${spaceXS};
`;
